import {
  UpsertPersonRequest,
  UpsertPersonResponse,
  UpsertPersonOptions,
  ApiClient,
} from "@quotientjs/core"
import {
  AsyncStorageProvider,
  StorageProvider,
} from "@quotientjs/browser-storage"
import { PersonIdStore } from "../stores/person-id"

export class People {
  private apiClient: ApiClient
  private provider: StorageProvider | AsyncStorageProvider

  constructor(
    apiClient: ApiClient,
    provider: StorageProvider | AsyncStorageProvider,
  ) {
    this.apiClient = apiClient
    this.provider = provider
  }

  async upsert(options: UpsertPersonOptions): Promise<UpsertPersonResponse> {
    const request = new UpsertPersonRequest(options)
    const response = await this.apiClient.call(request)
    if (this.provider.type === "sync") {
      PersonIdStore.set(this.provider as StorageProvider, response.personId)
    } else {
      PersonIdStore.setAsync(
        this.provider as AsyncStorageProvider,
        response.personId,
      )
    }
    return response
  }
}
